import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { trpc, trpcClient } from '@/utils/trpc';

interface TrpcProviderProps {
  children: React.ReactNode;
}

// Create QueryClient outside component to ensure stability
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable automatic retries for better error handling
      retry: false,
      // Cache for 5 minutes
      staleTime: 5 * 60 * 1000,
    },
  },
});

/**
 * tRPC Provider component
 * Wraps the app with tRPC and React Query providers
 */
export function TrpcProvider({ children }: TrpcProviderProps) {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </trpc.Provider>
  );
}